<template>
  <div class="home">
    <menuBox :step="1"></menuBox>
    <div class="home-1">
      <div class="text-1">We Are The Best Agency!</div>
      <div class="text-2">Build Your Business Easy Solution</div>
      <div class="text-3">EXTEND TECH PTE. LTD. is the best consectetuer adipiscing elit, sed diam nonum My nibh euismod tincidunt business agency.</div>
    </div>

    <div class="home-2">
      <div class="h2-text-1">We Are The Best Agency!</div>
      <div class="h2-text-2">Our Work Process</div>
      <div class="h2-list">
        <div class="h2-item">
          <img src="../assets/img-1.png" alt="">
          <div class="item-1">Strategic Consultation:</div>
          <div class="item-2">Begin your transformation with a personalized consultation. Our experts delve deep into your business goals, challenges, and aspirations to craft a tailored SAAS strategy.</div>
          <div class="item-3">LEARN MORE</div>
        </div>
        <div class="h2-item">
          <img src="../assets/img-2.png" alt="">
          <div class="item-1">Customized Solutions:</div>
          <div class="item-2">Armed with insights from the consultation, our team develops bespoke SAAS solutions. We believe in technology that fits seamlessly into your workflow, enhancing efficiency and productivity.</div>
          <div class="item-3">LEARN MORE</div>
        </div>
        <div class="h2-item">
          <img src="../assets/img-3.png" alt="">
          <div class="item-1">Implementation Excellence:</div>
          <div class="item-2">The transition to our SAAS solutions is a smooth ride. Our implementation process is marked by precision and expertise, ensuring minimal disruptions and maximum impact on your operations.</div>
          <div class="item-3">LEARN MORE</div>
        </div>
        <div class="h2-item">
          <img src="../assets/img-4.png" alt="">
          <div class="item-1">User-Centric Training:</div>
          <div class="item-2">Empower your team with the knowledge they need to leverage our SAAS tools effectively. We provide comprehensive training programs designed with a user-centric approach, making adoption a breeze.</div>
          <div class="item-3">LEARN MORE</div>
        </div>
        <div class="h2-item">
          <img src="../assets/img-5.png" alt="">
          <div class="item-1">Continuous Optimization:</div>
          <div class="item-2">Our commitment doesn’t end with implementation. We continuously monitor and optimize the performance of our SAAS solutions, ensuring they evolve alongside your business needs.</div>
          <div class="item-3">LEARN MORE</div>
        </div>
        <div class="h2-item">
          <img src="../assets/img-6.png" alt="">
          <div class="item-1">Dedicated Support:</div>
          <div class="item-2">Experience peace of mind with our dedicated support team. Whether it's troubleshooting, updates, or clarifications, our support is just a click or call away, ensuring uninterrupted business continuity.</div>
          <div class="item-3">LEARN MORE</div>
        </div>
      </div>
    </div>

    <div class="home-3">
      <div class="home-box">
        <div class="h3-text-1">Collaboration Showcase</div>
        <div class="h3-text-2">Empowering Success Together</div>
        <div class="h3-text-3">At EXTEND TECH, we believe in the power of collaborative success stories. Explore how our SAAS solutions have transformed businesses across industries, creating a ripple effect of efficiency and innovation.</div>
      </div>
    </div>

    <div class="home-4">
      <div class="h4-text-1">Portfolio</div>
      <div class="h4-text-2">Recent Completed Projects</div>
      <div class="h4-box">
        <img src="../assets/img-7.png" alt="">
        <img src="../assets/img-8.png" alt="">
        <img src="../assets/img-9.png" alt="">
        <img src="../assets/img-10.png" alt="">
        <img src="../assets/img-11.png" alt="">
        <img src="../assets/img-12.png" alt="">
      </div>
    </div>

    <div class="home-5">
      <div class="h5-text-1">Testimonial</div>
      <div class="h5-text-2">Our Client Reviews</div>
      <div class="pl-box">
        <div class="pl-item">
          <img src="../assets/img-13.png" alt="">
          <div class="pl-text">“EXTEND TECH's SAAS solutions revolutionized our workflow, driving unparalleled growth and efficiency. Their commitment to understanding our unique challenges set them apart.” - John Doe, CEO, XYZ Enterprises</div>
          <p>Enterprises</p>
          <div>Transforming Operations for Unparalleled Growth</div>
        </div>
        <div class="pl-item">
          <img src="../assets/img-14.png" alt="">
          <div class="pl-text">“Partnering with EXTEND TECH was a game-changer for us. Their SAAS solutions not only streamlined our processes but also opened new avenues for innovation. Truly a strategic partnership that exceeded expectations.” - Jane Smith, CTO, ABC Innovations</div>
          <p>Innovations</p>
          <div>Innovation Unleashed: A Strategic Partnership</div>
        </div>
      </div>
    </div>

    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";

export default {
  name: 'App',
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>


<style lang="less" scoped>
.home-1 {
  background: url(../assets/home-1.png);
  height: 942px;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  .text-1 {
    height: 32px;
    line-height: 32px;
    background: fade(#3DA685, 30%);
    border-radius: 4px;
    padding: 0px 30px;
    font-size: 16px;
    font-weight: 600;
    color: #3DA685;
  }

  .text-2 {
    font-size: 72px;
    font-weight: 600;
    color: #FFFFFF;
    width: 720px;
    margin-top: 10px;

  }

  .text-3 {
    font-size: 16px;
    font-weight: 600;
    color: #FFFFFF;
    width: 543px;
    margin-top: 16px;
  }
}

.home-2 {
  padding: 120px 300px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .h2-text-1 {
    font-size: 16px;
    font-weight: 600;
    color: #3DA685;
    padding: 10px 28px;
    background: fade(#3DA685, 30%);
  }

  .h2-text-2 {
    font-size: 64px;
    font-weight: 600;
    color: #0F1010;
    margin-top: 13px;
  }

  .h2-list {
    margin-top: 80px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;

    .h2-item {
      width: 415px;
      height: 490px;
      background: #F2FFFB;
      border-radius: 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 40px;

      img {
        width: 92px;
        margin-top: 48px;
      }

      .item-1 {
        font-size: 24px;
        font-weight: 600;
        color: #0F1010;
        margin-top: 26px;
        width: 350px;
        text-align: center;
      }

      .item-2 {
        font-size: 18px;
        color: #999999;
        margin-top: 19px;
        width: 350px;
        text-align: center;
      }

      .item-3 {
        height: 56px;
        background: #3DA685;
        border-radius: 8px;
        font-size: 18px;
        color: #FFFFFF;
        padding: 0px 28px;
        line-height: 56px;
        margin-top: 32px;
      }
    }
  }
}

.home-3 {
  background: url(../assets/home-3.png);
  background-size: 100% 100%;
  height: 760px;

  .home-box {
    margin-left: 1000px;
    height: 760px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 615px;

    .h3-text-1 {
      height: 32px;
      line-height: 32px;
      background: fade(#3DA685, 30%);
      border-radius: 4px;
      padding: 0px 30px;
      font-size: 16px;
      font-weight: 600;
      color: #3DA685;
    }

    .h3-text-2 {
      font-size: 64px;
      font-weight: 600;
      color: #0F1010;
      margin-top: 32px;
    }

    .h3-text-3 {
      font-size: 18px;
      font-weight: 400;
      color: #999999;
      margin-top: 32px;
    }
  }
}

.home-4 {
  padding: 120px 300px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .h4-text-1 {
    font-size: 16px;
    font-weight: 600;
    color: #3DA685;
    padding: 10px 28px;
    background: fade(#3DA685, 30%);
  }

  .h4-text-2 {
    font-size: 64px;
    font-weight: 600;
    color: #0F1010;
    margin-top: 13px;
  }

  .h4-box {
    margin-top: 80px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;

    img {
      width: 415px;
      margin-bottom: 40px;
    }
  }
}

.home-5 {
  background: #0F1010;
  padding: 80px 300px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .h5-text-1 {
    font-size: 16px;
    font-weight: 600;
    color: #3DA685;
    padding: 10px 28px;
    background: fade(#3DA685, 30%);
  }

  .h5-text-2 {
    font-size: 64px;
    font-weight: 600;
    color: #fff;
    margin-top: 13px;
  }

  .pl-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 80px;
    width: 1320px;
    // flex-grow: 1;

    .pl-item {
      background: url(../assets/img-box.png);
      background-size: 100% 100%;
      width: 642px;
      height: 345px;

      img {
        width: 64px;
        margin-top: 32px;
        margin-left: 32px;
      }

      div {
        font-size: 18px;
        font-weight: 400;
        color: #999999;
        margin-left: 32px;
      }

      .pl-text {
        margin-top: 24px;
        margin-left: 32px;
        font-size: 18px;
        font-weight: 400;
        color: #999999;
        width: 533px;
        min-height: 100px;
      }

      p {
        font-size: 18px;
        font-weight: 600;
        margin-top: 24px;
        margin-top: 24px;
        margin-left: 32px;
      }
    }
  }
}
</style>
